import { hasStaticCare } from "core/model/patients";
import { Auction, GetOntologyType } from "core/types";
import { PatientProfileInfoCard } from "dsl/organisms/PatientProfileDetailsShared/shared";
import Translations from "translations/types";
import {
  MedicalMobileCareInformation,
  MedicalStaticCareInformation,
} from "./AdmissionsMedicalInformationCard";

export function AdmissionsMedicalInformationCardPrint({
  auction,
  getOntology,
  isSealdOnly,
  translations,
  withEncryptionAccess,
}: {
  auction: Auction;
  getOntology: GetOntologyType;
  translations: Translations;
  isSealdOnly: boolean;
  withEncryptionAccess: boolean;
}) {
  return (
    <PatientProfileInfoCard
      title={
        translations.careproviderApp.recareAdmissionsForm.medicalInformation
          .title
      }
    >
      <MedicalMobileCareInformation
        auction={auction}
        getOntology={getOntology}
        translations={translations}
      />
      {!!hasStaticCare(auction.solutions) && (
        <MedicalStaticCareInformation
          auction={auction}
          getOntology={getOntology}
          isSealdOnly={isSealdOnly}
          translations={translations}
          withEncryptionAccess={withEncryptionAccess}
        />
      )}
    </PatientProfileInfoCard>
  );
}
